import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const FileSearch = createIcon({
  Root: Svg,
  viewBox: "0 0 40 40",
  path: (
    <>
      <Path
        d="M23.3332 18.334H13.3332M16.6665 25.0007H13.3332M26.6665 11.6673H13.3332M33.3332 17.5007V11.334C33.3332 8.53372 33.3332 7.13359 32.7882 6.06403C32.3088 5.12322 31.5439 4.35832 30.6031 3.87895C29.5336 3.33398 28.1334 3.33398 25.3332 3.33398H14.6665C11.8662 3.33398 10.4661 3.33398 9.39655 3.87895C8.45574 4.35832 7.69084 5.12322 7.21147 6.06403C6.6665 7.13359 6.6665 8.53372 6.6665 11.334V28.6673C6.6665 31.4676 6.6665 32.8677 7.21147 33.9373C7.69084 34.8781 8.45574 35.643 9.39655 36.1223C10.4661 36.6673 11.8662 36.6673 14.6665 36.6673H19.1665M36.6665 36.6673L34.1665 34.1673M35.8332 30.0007C35.8332 33.2223 33.2215 35.834 29.9998 35.834C26.7782 35.834 24.1665 33.2223 24.1665 30.0007C24.1665 26.779 26.7782 24.1673 29.9998 24.1673C33.2215 24.1673 35.8332 26.779 35.8332 30.0007Z"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export { FileSearch };
